import { TokenCell, Pnl, ResultBadge, ExtLink, openToken, fmtUsd, fmtHold, fmtDay, fmtTime } from './anUi';

const STATUS_LEVEL = (p) => {
  if (!p.closed) return { label: 'En cours', cls: 'an-status--0' };
  if (p.roi >= 200) return { label: 'Très rentable', cls: 'an-status--3' };
  if (p.roi >= 0) return { label: 'Rentable', cls: 'an-status--2' };
  return { label: 'Non rentable', cls: 'an-status--1' };
};

// variant "best" : Meilleurs Tokens (1ER ACHAT) — variant "full" : onglet Tokens (DURÉE MOY)
export function TokensTable({ rows, variant = 'full' }) {
  return (
    <div className="an-table-wrap">
      <table className="an-table">
        <thead>
          <tr>
            <th>🪙 Token</th><th>📈 ROI</th><th>🔄 Trades</th><th>💰 Investi</th>
            {variant === 'best' ? <th>📅 1er achat</th> : <th>⏱ Durée moy</th>}
            <th>🏷 Statut</th><th>↗</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(p => {
            const st = STATUS_LEVEL(p);
            return (
              <tr key={p.mint} className="an-row an-row--click" onClick={() => openToken(p.mint)}>
                <td><TokenCell p={p} /></td>
                <td className="an-cell-num"><Pnl value={p.roi} /></td>
                <td className="an-cell-num">{p.trades}</td>
                <td className="an-cell-num">{fmtUsd(p.investedUsd)}</td>
                <td className="an-cell-num an-muted">{variant === 'best' ? fmtDay(p.entreeTs) : fmtHold(p.dureeMin)}</td>
                <td><span className={`an-status ${st.cls}`}>{st.label}</span></td>
                <td><ExtLink mint={p.mint} /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// Trades / Stats Explorer : ENTRÉE, TOKEN, ACHAT, VENTE, ROI, DURÉE, RÉSULTAT
export function PositionsTable({ rows }) {
  return (
    <div className="an-table-wrap">
      <table className="an-table">
        <thead>
          <tr>
            <th>📅 Entrée</th><th>🪙 Token</th><th>💰 Achat</th><th>💸 Vente</th>
            <th>📈 ROI</th><th>⏱ Durée</th><th>🏁 Résultat</th><th>↗</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((p, i) => (
            <tr key={`${p.mint}-${i}`} className="an-row an-row--click" onClick={() => openToken(p.mint)}>
              <td className="an-cell-num"><div>{fmtTime(p.entreeTs)}</div><div className="an-muted an-small">{fmtDay(p.entreeTs)}</div></td>
              <td><TokenCell p={p} /></td>
              <td className="an-cell-num">{fmtUsd(p.achatUsd)}</td>
              <td className="an-cell-num">{fmtUsd(p.venteUsd)}</td>
              <td className="an-cell-num"><Pnl value={p.roi} /></td>
              <td className="an-cell-num an-muted">{fmtHold(p.dureeMin)}</td>
              <td><ResultBadge resultat={p.resultat} /></td>
              <td><ExtLink mint={p.mint} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
